<template lang="pug">
  el-dialog(v-dialog-drag title="选择成员范围"
    modal-append-to-body append-to-body
    width="1200px"
    top='40px'
    :visible.sync="show",
    :close-on-click-modal="false",
    @close="closeHandler" )
    div.content
      .top
        el-radio-group(v-model="type" size="small" @input="radioHandler" )
          el-radio-button( v-for="(it, index) in typeList" :key="index" :label="it.subjectCode" @click.native="radioClick") {{it.subjectName}}
        el-input.search(v-model="keyword" size="small" placeholder="请输入关键字" clearable)
      .center(v-loading="loading")
        splitpanes.default-theme(split="horizontal")
          pane(min-size="20" size="30" max-size="90")
            .left
              el-tree.tree(v-if="treeData.length>0"
                ref="tree"
                :data="treeData"
                :node-key="treeProps.nodeKey"
                :props="treeProps"
                :show-checkbox='canSelect'
                :default-expanded-keys="defaultExpandedKeys"
                :default-checked-keys='defaultCheckedKeys'
                :expand-on-click-node='false'
                :filter-node-method='filterMethod'
                :check-strictly='checkStrictly'
                @check="checkHandler"
                @node-click="handleNodeClick" )
              el-empty(description="暂无数据" v-else )
          pane(v-if="showTable" mini-size="40" size="40")
            .right
              el-input.search(v-model="keyword2" clearable size="small" placeholder="请输入关键字搜索人员" )
              .table
                el-table(
                  ref="multipleTable"
                  :data="tableData"
                  border
                  size="small" height="calc(80vh - 190px)"
                  @select="selectChange")
                  el-table-column(type="selection"  width="42" header-align="center" align="center" )
                  el-table-column(show-overflow-tooltip align="center" label="姓名" prop="fullName" sortable v-slot="{row}")
                    span {{ row.fullName }}{{ row.isHead ? '【负责人】' : '' }}
                  el-table-column(show-overflow-tooltip align="center" label="账号" prop="userName" sortable)
                  el-table-column(show-overflow-tooltip prop="orgName" align="center" label="所在部门" sortable)
              .page
                el-pagination(
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="page.pageIndex"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="page.pageSize"
                  :layout="page.pageLayout"
                  :total="page.totalCount")

          pane(size="30" mini-size="30")
            .ac()
              .tip 已选（{{nowSelect.length}}）
              div.tag-block(v-for="(it) in nowSelect" :key="it.subjectName")
                .name {{it.subjectName}}：
                .tag-con
                  el-tag.tag(v-for="(tag,index) in it.subjectValues" :key="index" size="mini"
                    @close="deleteValue(it.subjectValues,index)" closable)  {{tag.label}}
    template(#footer)
      div
        .right
          el-button( size="small" @click="close" ) 取消
          el-button(type="primary" size="small" @click="confirmHandler" ) 确定
</template>

<script>
import strategyAuthService from '@/CommonDP/service/strategyAuth-service';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';
import { mapState } from 'vuex';

export default {
  name: 'AuthGroupSubjectDialog',
  components: { Splitpanes, Pane },
  props: {
    selected: {
      type: Array,
      default: () => []
    },
    checkStrictly: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      show: false,
      loading: false,
      keyword: '',
      keyword2: '',
      typeList: [],
      type: '',
      treeData: [],
      tableData: [],
      defaultExpandedKeys: [],
      defaultCheckedKeys: [],
      showTableRoleKey: 'User', // 指定用户的时候选择人员
      sysTreeProps: {
        children: 'children',
        label: 'roleName',
        nodeKey: 'roleID'
      },
      specTreeProps: {
        children: 'children',
        label: 'roleName',
        nodeKey: 'roleId'
      },
      prjTreeProps: {
        children: 'children',
        label: 'roleName',
        nodeKey: 'roleID'
      },
      orgTreeProps: {
        children: 'children',
        label: 'deptName',
        nodeKey: 'deptId'
      },
      personConfig: {
        label: 'fullName',
        nodeKey: 'userId',
        phoneKey: 'mobilePhone'
      },
      treeProps: {},
      page: {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: 'total, sizes, prev, pager, next, jumper'
      },
      filter: {
        roleIds: []
      },
      currentNode: {},
      personSelectList: [],
      result: [],
      selectedMap: new Map(),
      nowSelect: []
    };
  },
  computed: {
    showTable () {
      return this.type === this.showTableRoleKey;
    },
    canSelect () {
      return !this.showTable;
    },
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })

  },
  watch: {
    selected: {
      handler (nl) {
        console.log(nl);
        this.initSelect();
      }
    },
    keyword(val) {
      this.$refs.tree.filter(val);
    },
    keyword2() {
      this.resetPage();
      this.getOrgPersonList();
    }
  },
  created () {},
  methods: {
    open (typeList) {
      this.defaultCheckedKeys = [];
      this.personSelectList = [];
      this.show = true;
      this.typeList = typeList;
      //  初始化所有的类型为空
      this.typeList.forEach(item => {
        this.selectedMap.set(item.nodeKey, {});
      });
      this.initSelect();
    },
    close () {
      this.show = false;
      this.closeHandler();
    },
    freshNowSelect() {
      this.nowSelect = [];
      this.nowSelect = this.getSelectData();
    },
    initSelect () {
      const nl = this.selected;
      this.defaultCheckedKeys = [];
      if (nl && nl.length > 0) {
        // 默认radio 显示 第一个选中的
        const first = nl[0];
        if (first) {
          this.type = first.subjectCode;
          first.subjectValues.forEach(v => {
            //  展示人员列表时存储 personList
            if (this.type === this.showTableRoleKey) {
              const personConfig = this.personConfig;
              this.personSelectList = first.subjectValues.map(it => {
                return {
                  [personConfig.nodeKey]: first.value,
                  [personConfig.label]: first.label
                };
              });
            } else {
              // 其他情况为树，只需要设置elementUI tree 的 默认选中项即可
              this.defaultCheckedKeys.push(v.values);
            }
          });
        }
        //  存储所有的 选中项
        nl.forEach(sub => {
          this.selectedMap.set(sub.subjectCode, sub);
        });
      } else {
        //  没选选中项时，显示第一列
        if (this.typeList.length > 0) {
          this.type = this.typeList[0].subjectCode;
        }
      }
      this.freshNowSelect();
      this.radioHandler(this.type);
    },
    // 已经选择的人员默认不可选择
    judgeSelect (row, index) {
      return !this.personSelectList.some(e => e.userId === row.id); // 返回true该行可选，返回false则不可选
    },
    deleteValue (array, index) {
      array.splice(index, 1);
    },
    radioClick (e) {
      // 首先获取到type的值，然后根据该值调用 getSelectData 获取选中的值，并存储到 selectedMap 对应的key中
      this.cacheNowSelected();
    },
    cacheNowSelected () {
      const nowType = this.type;
      const data = this.getNowTreeSelect(nowType);
      this.selectedMap.set(nowType, data);
      this.freshNowSelect();
    },
    radioHandler (val) {
      this.type = val;
      this.keyword = '';
      this.dispatchRadioNext(this.showBeforeSelect, val);
    },
    showBeforeSelect (type) {
      const personConfig = this.personConfig;
      const beforeTab = this.selectedMap.get(type);
      this.defaultCheckedKeys = [];
      this.personSelectList = [];
      if (beforeTab) {
        if (beforeTab.subjectValues?.length > 0) {
          if (type === this.showTableRoleKey) {
            console.log(type);
            console.log(beforeTab.subjectValues);
            this.personSelectList = beforeTab.subjectValues.map(it => {
              return {
                [personConfig.nodeKey]: it.value,
                [personConfig.label]: it.label
              };
            });
            console.log('set person list ', this.personSelectList);
          } else {
            this.defaultCheckedKeys = beforeTab.subjectValues.map(it => it.value);
          }
        }
      }
    },
    async dispatchRadioNext (beforeFunction, type) {
      console.log('radio type', this.type);
      this.treeData = [];
      const map = {
        SystemRole: this.getSysRoleList,
        SpecRole: this.getSpecRoleList,
        PrjRole: this.getPrjRoleList,
        Label: '',
        Position: '',
        Dept: this.getOrgTree,
        User: this.getOrgTree
      };

      const propsConfig = this.getTreePropsMap(this.type);
      if (propsConfig) {
        this.treeProps = propsConfig;
      }
      if (beforeFunction) {
        beforeFunction(type);
      }
      const fun = map[this.type];
      if (fun) {
        this.loading = true;
        try {
          await fun();
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      } else {
        console.error(`没有${this.type}的处理方法`);
      }
    },
    /**
     * 获取对应的 key 所对应的 propsConfig
     * @param key
     * @returns {Object}
     */
    getTreePropsMap (key) {
      const map = {
        SystemRole: this.sysTreeProps,
        SpecRole: this.specTreeProps,
        PrjRole: this.prjTreeProps,
        Label: '',
        Position: '',
        Dept: this.orgTreeProps,
        User: this.orgTreeProps
      };
      return map[key];
    },
    filterMethod(value, data) {
      console.log(value, data);
      if (!value) {
        return true;
      }
      const props = this.treeProps;
      return (data[props.label].indexOf(value) !== -1);
    },
    checkHandler () {
      this.cacheNowSelected();
    },
    handleNodeClick (data) {
      this.currentNode = data;
      this.page.pageIndex = 1;
      if (this.type === this.showTableRoleKey) {
        this.getOrgPersonList();
      }
      this.cacheNowSelected();
    },
    async setTableSelect () {
      const table = this.$refs.multipleTable;
      const personConfig = this.personConfig;
      const arr = [];
      await this.$nextTick();
      this.tableData.forEach(row => {
        const selected = this.personSelectList.find(it => {
          console.log('in find');
          console.log(row[personConfig.nodeKey]);
          console.log(it[personConfig.nodeKey]);
          return row[personConfig.nodeKey] === it[personConfig.nodeKey];
        });
        console.log(this.personSelectList);
        if (selected) {
          arr.push(row);
        }
        console.log('person selected', selected);
      });
      if (arr.length) {
        arr.forEach(row => {
          table.toggleRowSelection(row, true);
        });
      }
    },
    // 选择人员选择器
    selectChange (data) {
      console.log(data);
      this.personSelectList = data;
      this.cacheNowSelected();
    },
    confirmHandler () {
      const result = this.getSelectData();
      // const resultValue = this.getSelectValue();
      this.$emit('selected', result);
      this.close();
    },
    // 换分页尺寸
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.page.pageIndex = 1;
      this.getOrgPersonList();
    },
    // 翻页
    handleCurrentChange (val) {
      this.page.pageIndex = val;
      this.getOrgPersonList();
    },
    // 筛选
    handleFilter () {
      this.page.pageIndex = 1;
      this.getOrgPersonList();
    },
    async getSysRoleList () {
      const params = {
        enterpriseId: this.enterpriseId
      };
      const { data } = await strategyAuthService.querySysRoleList(params);
      this.treeData = data;
    },
    async getSpecRoleList () {
      const params = {
        enterpriseId: this.enterpriseId
      };
      const { data } = await strategyAuthService.querySpecRoleList(params);
      this.treeData = data;
    },
    async getPrjRoleList () {
      const params = {
        enterpriseId: this.enterpriseId
      };
      const { data } = await strategyAuthService.queryPrjoleList(params);
      this.treeData = data;
    },
    async getOrgTree () {
      this.tableData = [];
      const params = {
        enterpriseId: this.enterpriseId
      };
      const { data } = await strategyAuthService.queryDeptList(params);
      this.treeData = data;
      if (this.type === this.showTableRoleKey && data.length > 0) {
        this.currentNode = data[0];
        await this.getOrgPersonList();
      }
    },
    async getOrgPersonList () {
      this.tableData = [];
      const curNode = this.currentNode;
      const params = {
        orgId: curNode.deptId || this.treeData[0].deptId, // 必填
        keyword: this.keyword2,
        sysRoleId: this.filter.roleIds,
        pageNo: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      const { data, totalCount, pageIndex } = await strategyAuthService.queryDeptPersonList(params);
      this.page.pageIndex = pageIndex;
      this.page.totalCount = totalCount;
      this.tableData = data;
      this.setTableSelect();
    },
    resetData () {
      this.selectedMap.clear();
      this.treeData = [];
      this.tableData = [];
      this.defaultCheckedKeys = [];
      this.type = '';
      this.defaultExpandedKeys = [];
    },
    resetPage() {
      this.page.pageIndex = 1;
    },
    /**
     * 获取选中的数据
     * @param onlyValues 仅保留选中值， false values 数组会添加 label 展示
     * @returns {*[]}
     */
    getSelectData (onlyValues = false) {
      // const obj = this.getNowTreeSelect(onlyValues)
      const result = [];
      this.typeList.forEach(type => {
        const obj = this.selectedMap.get(type.subjectCode);
        if (obj && obj.subjectValues.length > 0) {
          result.push(obj);
        }
      });

      // result.push(obj);
      console.log('人员选中结果:', result);
      return result;
    },
    getNowTreeSelect (type) {
      const propConfig = this.treeProps;
      const personConfig = this.personConfig;
      const obj = {
        subjectCode: type,
        values: []
      };
      obj.subjectName = this.typeList.find(it => it.subjectCode === type).subjectName;
      if (type === this.showTableRoleKey) {
        obj.values = this.personSelectList.map(it => it[personConfig.nodeKey]);
        obj.subjectValues = this.personSelectList.map(it => {
          const item = {
            value: it[personConfig.nodeKey],
            label: it[personConfig.label]
          };
          if (it[personConfig.phoneKey]) {
            item.label = item.label + '(' + it[personConfig.phoneKey] + ')';
          }
          return item;
        });
        obj.subjectList = this.personSelectList.map(it => {
          return {
            ...it
          };
        });
      } else {
        const nodes = this.$refs?.tree?.getCheckedNodes() || [];
        console.log(nodes);
        obj.values = nodes.map(it => {
          return it[propConfig.nodeKey];
        });
        obj.subjectValues = nodes.map(it => {
          return {
            value: it[propConfig.nodeKey],
            label: it[propConfig.label]
          };
        });
        obj.subjectList = nodes.map(it => {
          return {
            ...it
          };
        });
      }
      return obj;
    },
    closeHandler () {
      this.resetData();
      this.$emit('close');
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  padding: 16px;
  max-height: 80vh;
  min-height: 80vh;
  overflow: auto;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .search {
      width: 300px;
    }
  }

  .ac {
    height: calc(80vh - 86px);
    box-sizing: border-box;
    overflow: auto;
    padding: 0 0 0 12px;

    .tip {
      color: #aaa;
      font-size: 14px;
      margin-bottom: 16px;
    }

    .tag-block {
      line-height: 1;
      display: flex;
      justify-content: flex-start;

      .name {
        width: 80px;
        flex-shrink: 0;
        font-size: 14px;
        color: #333;
        height: 32px;
        line-height: 20px;
      }

      .tag {
        margin-right: 12px;
        margin-bottom: 12px;
      }
    }
  }

  .center {
    padding-top: 16px;
    height: calc(80vh - 64px);
    overflow: auto;

    .left {
      height: 100%;
      overflow: auto;

      .tree {
        height: calc(80vh - 86px);
        overflow: auto;
      }
    }

    .right {
      overflow: auto;
      width: 100%;
      height: 100%;

      .search {
        width: calc(100% - 12px);
        margin: 12px 0;
      }

      .page {
        min-width: 500px;
        height: 50px;
        margin-top: auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
      }
    }
  }

  ::v-deep {
    .splitpanes.default-theme .splitpanes__pane {
      background-color: #fff;
    }
  }
}
</style>
